import { AxiosResponse } from 'axios';
import { apiClient, getAuthHeaders } from './index';
import { TokenStreamDeck, TokenStreamDeckFilter, TokenStreamDeckSort } from './types';

export const tokenStreamDeckApi = {
  /**
   * 모든 Token Stream Deck 목록을 조회합니다.
   * @returns Token Stream Deck 목록
   */
  async getAllTokenStreamDecks(): Promise<TokenStreamDeck[]> {
    try {
      const response: AxiosResponse<any> = await apiClient.get(
        '/fe-management-system/decks',
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ GET /fe-management-system/decks 에러:', error);
      throw error;
    }
  },

  /**
   * Token Stream Deck을 업데이트합니다.
   * @param deckId 덱 ID
   * @param request 업데이트 요청 (filter, sort, name)
   * @returns 업데이트된 Token Stream Deck
   */
  async updateTokenStreamDeck(
    deckId: string,
    request: {
      filter?: TokenStreamDeckFilter;
      sort?: TokenStreamDeckSort;
      name?: string;
    }
  ): Promise<TokenStreamDeck> {
    try {
      const response: AxiosResponse<any> = await apiClient.put(
        `/fe-management-system/decks/${deckId}`,
        request,
        {
          headers: getAuthHeaders(),
        }
      );

      return response.data.data;
    } catch (error) {
      console.error('❌ PUT /fe-management-system/decks/:deckId 에러:', error);
      throw error;
    }
  },
};
